import { Box, Button, Typography } from '@mui/material'
import { Project } from '../../models/Organization'
import { calculateAge } from '../../utils/Common'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

const filesSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.files,
)

interface RecentProjectProps {
  project: Project
}

const RecentProjectComponent: React.FC<RecentProjectProps> = ({ project }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const files = useSelector(filesSelector)

  const handleRecentProjectClick = () => {
    navigate(`${location.pathname}/${project.id}/files`)
  }

  return (
    <Button
      disableRipple
      onClick={handleRecentProjectClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        textTransform: 'none',
        p: 0,
        width: '100%',
        '&:hover': {
          background: 'transparent',
        },
      }}
    >
      <Box width='100%' display='flex' flexDirection='column' gap='1rem'>
        <Box display='flex' alignItems='center'>
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.94rem',

              color: '#04002E',
            }}
          >
            {project.name}
          </Typography>
        </Box>
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.82rem',

              color: '#04002E',
            }}
          >
            {files.filter((file) => file.project_id === project.id).length}{' '}
            Files
          </Typography>
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.58rem',

              color: '#04002E',
            }}
          >
            Updated: {calculateAge(project.updatedAt ?? Date.now().toString())}
          </Typography>
        </Box>
      </Box>
    </Button>
  )
}

export default RecentProjectComponent
